module.exports = __webpack_public_path__ + "img/payme.4d4d1d79.png";